import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream" data-id="element-29" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-5xl flex-col gap-2 px-6 py-12 md:flex-row md:items-baseline md:justify-between" data-id="element-30" data-mp="3gezcx2w41p0m">
        <p className="font-serif text-2xl text-ink" data-id="element-31" data-mp="32onkt3zizq9h">Curso Completo de IA para Emprendedores</p>
        <p className="text-base text-ink-faint" data-id="element-32" data-mp="36oo8zgcffftq">Aprende de alguien real, no de una teórica</p>
      </div>
    </footer>;
}